module.exports = __webpack_public_path__ + "static/img/hyy.0fbd388.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hyy.png
// module id = 1451
// module chunks = 3